/* ==========================================================================
   AURUM chrome interactivity for inner (Dawn) pages — announce dismiss, header
   scroll state, mobile menu, Shop mega menu, search overlay. This is ONLY the
   chrome block of the prototype main.js: the homepage-only handlers (contact
   modal, FAB, quick-view, fake cart, product generation) are deliberately left
   out so they never run on commerce pages and never intercept the real Dawn
   links. The header cart button is a plain /cart link (no JS needed).
   ========================================================================== */
(function () {
  "use strict";
  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

  /* Body scroll lock (shared by the menu + search overlays) */
  let scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.body.style.overflow = scrollLocks > 0 ? "hidden" : "";
  }

  /* Announcement bar dismiss */
  const announce = $("#announce");
  $("#announceClose")?.addEventListener("click", () => announce && announce.classList.add("is-hidden"));

  /* Header scroll state */
  const header = $("#header");
  const stickyCta = $(".sticky-cta");
  const onScroll = () => {
    const y = window.scrollY;
    if (header) header.classList.toggle("is-scrolled", y > 30);
    if (stickyCta) stickyCta.classList.toggle("is-visible", y > 600);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* Mobile menu */
  const menu = $("#mobileMenu");
  if (menu) {
    const openMenu = () => { menu.classList.add("is-open"); menu.setAttribute("aria-hidden", "false"); $("#menuOpen")?.setAttribute("aria-expanded", "true"); lockScroll(true); };
    const closeMenu = () => { menu.classList.remove("is-open"); menu.setAttribute("aria-hidden", "true"); $("#menuOpen")?.setAttribute("aria-expanded", "false"); lockScroll(false); };
    $("#menuOpen")?.addEventListener("click", openMenu);
    $("#menuClose")?.addEventListener("click", closeMenu);
    $$("#mobileMenu a").forEach((a) => a.addEventListener("click", closeMenu));
  }

  /* Shop mega-menu (hover is CSS; this adds click/touch toggle + Esc + close-on-pick) */
  const shopItem = $("#shopMega");
  const shopTrigger = $("#shopTrigger");
  if (shopItem && shopTrigger) {
    const closeMega = () => { shopItem.classList.remove("is-open"); shopTrigger.setAttribute("aria-expanded", "false"); };
    shopTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      const open = shopItem.classList.toggle("is-open");
      shopTrigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", (e) => { if (!shopItem.contains(e.target)) closeMega(); });
    shopItem.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeMega(); shopTrigger.focus(); } });
    $$(".mega a", shopItem).forEach((a) => a.addEventListener("click", closeMega));
  }

  /* Search overlay */
  const search = $("#searchOverlay");
  if (search) {
    const openSearch = () => { search.classList.add("is-open"); search.setAttribute("aria-hidden", "false"); lockScroll(true); setTimeout(() => $("#searchInput")?.focus(), 300); };
    const closeSearch = () => { search.classList.remove("is-open"); search.setAttribute("aria-hidden", "true"); lockScroll(false); };
    $("#searchOpen")?.addEventListener("click", openSearch);
    $("#searchClose")?.addEventListener("click", closeSearch);
    $$(".chip").forEach((c) => c.addEventListener("click", () => { const i = $("#searchInput"); if (i) { i.value = c.textContent; i.focus(); } }));
  }

  /* Contact modal — matches the homepage. Injected here so the [data-contact]
     nav link opens an intake form (posts to Basin "general" via MBMForms)
     instead of doing nothing on inner pages. */
  (function () {
    const EMAIL = "mintbymemphis@gmail.com";
    const MAILTO = "mailto:" + EMAIL;
    $$(".nav a, .mobile-menu a").forEach((a) => {
      const t = a.textContent.trim().toLowerCase();
      if (t === "contact" || t === "contact us") { a.textContent = "Contact Us"; a.setAttribute("data-contact", ""); a.setAttribute("href", "#"); }
    });
    const ov = document.createElement("div");
    ov.className = "contact-overlay";
    ov.id = "contactOverlay";
    ov.setAttribute("aria-hidden", "true");
    ov.innerHTML =
      '<div class="contact-modal" role="dialog" aria-modal="true" aria-label="Contact us">' +
        '<button class="contact-modal__close icon-btn" id="contactClose" aria-label="Close"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '<span class="eyebrow eyebrow--center">Get in Touch</span>' +
        '<h3 class="contact-modal__title">Contact Us</h3>' +
        '<p class="contact-modal__text">Tell us a bit about what you would like to discuss, and a real person (us) will get back to you fast.</p>' +
        '<form id="contactForm" novalidate>' +
          '<div class="field"><label for="c-name">Name</label><input id="c-name" name="name" type="text" autocomplete="name" required /><span class="field__error" data-for="c-name"></span></div>' +
          '<div class="field"><label for="c-email">Email</label><input id="c-email" name="email" type="email" autocomplete="email" required /><span class="field__error" data-for="c-email"></span></div>' +
          '<div class="field"><label for="c-msg">What would you like to discuss?</label><textarea id="c-msg" name="message" rows="3" required placeholder="A card, an order, selling a collection..."></textarea><span class="field__error" data-for="c-msg"></span></div>' +
          '<div id="contactTurnstile" style="margin:0 0 12px; display:flex; justify-content:center;"></div>' +
          '<button class="btn btn--gold btn--block" type="submit">Send Message</button>' +
        '</form>' +
        '<p class="contact-modal__note">Prefer email? <a href="' + MAILTO + '">' + EMAIL + '</a></p>' +
        '<div class="contact-modal__success" id="contactSuccess" hidden role="status"><svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m8 12 3 3 5-6"/></svg><h3>Message sent</h3><p>Thank you. We will get back to you within 24 hours.</p></div>' +
      '</div>';
    document.body.appendChild(ov);
    let contactToken = null;   /* Turnstile mounts on first open (reveal-render) */
    const openContact = () => {
      ov.classList.add("is-open"); ov.setAttribute("aria-hidden", "false"); lockScroll(true);
      if (!contactToken && window.MBMForms && MBMForms.turnstileMount) contactToken = MBMForms.turnstileMount(ov.querySelector("#contactTurnstile"));
    };
    const closeContact = () => { if (!ov.classList.contains("is-open")) return; ov.classList.remove("is-open"); ov.setAttribute("aria-hidden", "true"); lockScroll(false); };
    document.addEventListener("click", (e) => {
      if (!e.target.closest) return;
      const trigger = e.target.closest("[data-contact]");
      if (trigger && !trigger.closest(".contact-modal")) { e.preventDefault(); openContact(); return; }
      if (e.target === ov) closeContact();
    });
    ov.querySelector("#contactClose")?.addEventListener("click", closeContact);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeContact(); });
    if (window.MBMForms && MBMForms.wire) {
      MBMForms.wire(ov.querySelector("#contactForm"), {
        subject: "New contact message (mintbymemphis.com)",
        kind: "contact",   /* Turnstile-protected Basin form 71602 */
        autoresponse: "Thanks for reaching out to Mint By Memphis. We have your message, and a real person will get back to you within 24 hours.\n\nMint By Memphis Co.",
        collect: () => {
          const name = ov.querySelector("#c-name"), email = ov.querySelector("#c-email"), msg = ov.querySelector("#c-msg");
          const setE = (id, m) => { const el = ov.querySelector('.field__error[data-for="' + id + '"]'); if (el) el.textContent = m || ""; };
          let ok = true;
          if (!name.value.trim()) { setE("c-name", "Please enter your name."); ok = false; } else setE("c-name", "");
          if (!MBMForms.emailValid(email.value)) { setE("c-email", "Please enter a valid email."); ok = false; } else setE("c-email", "");
          if (!msg.value.trim()) { setE("c-msg", "Please add a brief note."); ok = false; } else setE("c-msg", "");
          if (!ok) return null;
          return { Name: name.value.trim(), Email: email.value.trim(), Message: msg.value.trim(), "cf-turnstile-response": contactToken ? contactToken() : "" };
        },
        onSuccess: () => { ov.querySelector("#contactForm").hidden = true; ov.querySelector("#contactSuccess").hidden = false; }
      });
    }
  })();
})();

/* ----------------------------------------------------------------------------
   REVEAL-ON-SCROLL (ported from the prototype main.js) — the AURUM Sell/About
   sections use .reveal[data-reveal-delay] which start hidden (opacity:0). Reveal
   them on view; if reduced-motion or no IntersectionObserver, show all at once so
   content can never get stuck invisible.
   -------------------------------------------------------------------------- */
(function () {
  function run() {
    var els = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.revealDelay || "0", 10);
        setTimeout(function () { el.classList.add("is-visible"); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: if anything is still hidden after 3s, force it visible.
    setTimeout(function () {
      els.forEach(function (el) { if (!el.classList.contains("is-visible")) el.classList.add("is-visible"); });
    }, 3000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
